import VerifyOutItemIssue from "../../../../components/@documents/item_issues/VerifyOutItemIssue";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemIssueVerifyOutPage() {

    return (
        <VerifyOutItemIssue 
            routeType={routeTypes.admin}
        />
    )
}